// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__TVD5X","logo":"Header_logo__9PMfV","title":"Header_title__xrS19"};